import React from 'react';
/*
import {
  hf,
  hfDTM,
  ht,
  cr,
  a,
  ls,
  gs,
  BoxC,
  DldC,
} from 'lib';
*/
import * as BoxC from "./_ccbBoxC";
import * as DldC from "./_ccmDldC";
import * as cr from './_cr';
import { a } from "./_csAbt";
import * as gs from "./_csGbl";
import * as ls from "./_csLcl"; // local state
import * as ht from './_ht';
import * as hfDTM from './_hfDTM';

import * as icm from './icm';
import * as icvI18___EzE from './icvI18___EzE';
import * as icvI1z___EzE1 from './icvI1z___EzE1';
import * as icvI1z___EzE2 from './icvI1z___EzE2';
import * as icvI1z___EzE3 from './icvI1z___EzE3';
import * as icvI1z___EzE4 from './icvI1z___EzE4';
import * as icvI1z___EzE5 from './icvI1z___EzE5';
import * as icvI1z___EzE6 from './icvI1z___EzE6';

import * as icvBaseS10Rz from './icvBaseS10Rz';

export const N = (pz: {
  sPz: ht.dz,
}) => {

  const _gUserz = gs.useUserz();

  const _sPz = ls.usePz({
    steps: [0],
  });

  const _dlds = [

    icm.chkPmn('11023') ?
    {
      pfx: '実績集計表',
      bYearMth: true,
      dldAsync: async (_cdnz: ht.dz) => {
        await icvI1z___EzE3.eptExlAsync({
          _31r_fst: _gUserz.crt._31rz._fst,
          yearMth: hfDTM.grtYearMth(_cdnz.year, _cdnz.mth),
        })
      }
    }
    : undefined,

    icm.chkPmn('11021') ?
    {
      pfx: '予約一覧',
      bYearMth: true,
      dldAsync: async (_cdnz: ht.dz) => {
        await icvI1z___EzE1.eptExlAsync({
          _31r_fst: _gUserz.crt._31rz._fst,
          yearMth: hfDTM.grtYearMth(_cdnz.year, _cdnz.mth),
          ctt: 'r',
        })
      }
    }
    : undefined,

    icm.chkPmn('12121') ?
    {
      pfx: 'エントリー一覧',
      bYearMth: true,
      dldAsync: async (_cdnz: ht.dz) => {
        await icvI1z___EzE1.eptExlAsync({
          _31r_fst: _gUserz.crt._31rz._fst,
          yearMth: hfDTM.grtYearMth(_cdnz.year, _cdnz.mth),
          ctt: 'e',
        })
      }
    }
    : undefined,

    icm.chkPmn('11022') ?
    {
      pfx: '利用者数一覧',
      bYearMth: true,
      dldAsync: async (_cdnz: ht.dz) => {
        await icvI1z___EzE2.eptExlAsync({
          _31r_fst: _gUserz.crt._31rz._fst,
          yearMth: hfDTM.grtYearMth(_cdnz.year, _cdnz.mth),
        })
      }
    }
    : undefined,

    icm.chkPmn('2z121') ?
    {
      pfx: '団体一覧',
      bYearMth: false,
      dldAsync: async (_cdnz: ht.dz) => {
        await icvI18___EzE.eptExlAsync({
          _31r_fst: _gUserz.crt._31rz._fst,
        })
      }
    }
    : undefined,

    icm.chkPmn('11024') ?
    {
      pfx: '使用状況一覧',
      bYearMth: true,
      dldAsync: async (_cdnz: ht.dz) => {
        await icvI1z___EzE4.eptExlAsync({
          _31r_fst: _gUserz.crt._31rz._fst,
          yearMth: hfDTM.grtYearMth(_cdnz.year, _cdnz.mth),
        })
      }
    }
    : undefined,

    icm.chkPmn('11021') ?
    {
      pfx: '削除済予約一覧',
      bYearMth: true,
      dldAsync: async (_cdnz: ht.dz) => {
        await icvI1z___EzE5.eptExlAsync({
          _dmn: _gUserz.crt._dmn,
          _31r_fst: _gUserz.crt._31rz._fst,
          yearMth: hfDTM.grtYearMth(_cdnz.year, _cdnz.mth),
          ctt: 'r',
        })
      }
    }
    : undefined,

    icm.chkPmn('11021') ?
    {
      pfx: 'キャンセル済予約一覧',
      bYearMth: true,
      dldAsync: async (_cdnz: ht.dz) => {
        await icvI1z___EzE6.eptExlAsync({
          _dmn: _gUserz.crt._dmn,
          _31r_fst: _gUserz.crt._31rz._fst,
          yearMth: hfDTM.grtYearMth(_cdnz.year, _cdnz.mth),
          ctt: 'r',
        })
      }
    }
    : undefined,

  ];

/*
  React.useEffect(() => {
hf.l(`icvHomeS20Rz 117: here`)
    _sPz.udtAll();
  }, [
    _gUserz.crt._40rz
  ])  
*/
  const _udtThis = ls.udtThis();
  icm.loadAtTopAsync({
    _31r_fst: _gUserz.crt._31rz?._fst,
    frcUdt: _udtThis,
  });

//hf.l(`icvHomeS20Rz 123: ${hf.s(_gUserz.crt._40rz)}`)
//hf.l(`icvHomeS20Rz 124: ${hf.s(_dlds)}`)
  return (
    cr.c(icvBaseS10Rz.N, {
      key: -10,
      sPz: _sPz,
      cz: {
        pageName: 'データダウンロード',
      },
      oClds: [
        cr.c(BoxC.N, {
          key: -10,
          boxStlz: a(`dw/40 f/1 fd/ccc`),
          oClds: [
            cr.c(DldC.N, {
              key: -10,
              cz: {
                dlds: _dlds,
                clr: 'gn',
              }
            })
          ]
        })
      ]
    })

  );
};
